
export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: '주거 공간 디자인',
      description: '당신의 라이프스타일과 가치를 반영하는 맞춤형 주택. 컨셉부터 완공까지, 아름답고 개인적인 생활 공간을 창조하여 당신의 삶의 방식에 맞춰 설계합니다.'
    },
    {
      icon: 'ri-building-line',
      title: '상업 공간',
      description: '생산성과 브랜드 아이덴티티를 향상시키는 혁신적인 오피스 및 리테일 환경. 협업을 고취하고 지속적인 인상을 남기는 상업 공간을 디자인합니다.'
    },
    {
      icon: 'ri-tools-line',
      title: '리모델링',
      description: '기존 구조물을 활기찬 새로운 공간으로 변화시킵니다. 역사적 건물에 새로운 생명을 불어넣어 과거를 존중하면서도 기능적이고 현대적인 환경을 창조합니다.'
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-20 lg:py-32 bg-[#F5F2ED]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12">
        <div className="mb-10 sm:mb-16">
          <p className="text-xs tracking-widest text-gray-400 mb-3 sm:mb-4 uppercase">제공 서비스</p>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
            종합적인<br />디자인 서비스
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#EEEBE6] rounded-2xl p-7 sm:p-8 lg:p-12 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${service.icon} text-3xl sm:text-4xl text-gray-900`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">{service.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
